<template>
    <h1>Gestão de férias</h1>
    <!-- <DefaultVacationDaysForm
        action="show"
    />
    <hr class="my-10"> -->
    <AbsenceRequestDefaultVacationDaysTable />

</template>

<script setup>
import AbsenceRequestDefaultVacationDaysTable from '../../../components/absences/requests/AbsenceRequestDefaultVacationDaysTable.vue';
import DefaultVacationDaysForm from '../../../components/absences/requests/DefaultVacationDaysForm.vue';

</script>